
import { useState } from "react";
import bot from "../../assets/images/happy.png";

import you from '../../assets/images/boy.png';
import GetInTouch from "./GetInTouch";

const ContactUs = () =>{
    
      const [time] = useState(new Date().toLocaleTimeString());

      const [showFrame, setShowFrame] = useState(false);

    return(
        <>
         <div className="chatbot">
            <img src={bot} alt="bot" className="bot" />
            <div className="chatbot-time">{time}</div>
        </div>
        <div className="frame1 animated-frame">
            <center><h2>Contact Us</h2></center>
             <strong>CALL:</strong> +91 9246 222 821 <br></br><br></br>
             <strong>MAIL:</strong> support@agromech.com <br></br><br></br>
             <strong>ADDRESS:</strong><br></br> B-7, Industrial Estate, Sanath Nagar Rd, near Little Scholar School, Sanath Nagar, Hyderabad, Telangana 500018.<br></br><br></br>
             <strong>Opening Hours:</strong><br></br>
             MON to SAT: 9:00AM - 10:00PM<br></br>
             SUN: 09:00AM - 10:00PM<br></br><br></br>
            <div style={{textAlign: 'center'}}>
             <button className="detatils-button2" onClick={() => setShowFrame(true)}>Get in Touch</button>
             </div>
        </div>

        {showFrame && (
            <>
            <div className="you-time">
          <img src={you} alt="boy" className="boy" />
          You {time}
        </div>
        <div className="you-message">
          <div className="frame2">Get In Touch</div>
        </div>
                <GetInTouch />
            </>
            )}


        </>
    );
}
export default ContactUs;